export default "__VITE_ASSET__Br3A8aa9__"